import { Link } from "gatsby"
import React from "react"

const Button = ({ size = "xs", color = "transparent", styles, children }) => {
  let colorStyles
  let sizeStyles

  if (color === "blue") {
    colorStyles = "bg-lightblue text-white"
  } else if (color === "black") {
    colorStyles = "bg-black text-white"
  } else {
    colorStyles = "bg-transparent border-2 border-black text-black"
  }

  if (size === "xs") {
    sizeStyles = "px-[36px] py-[12px] text-[14px]"
  } else {
    sizeStyles = "px-[55px] py-[16px] text-[16px]"
  }

  return (
    <div className={styles}>
      <Link
        className={`${colorStyles} ${sizeStyles} font-ubuntu font-bold`}
        to="/"
      >
        {children}
      </Link>
    </div>
  )
}

export default Button
